// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".scenario-edit{margin-left:5px;margin-top:10px}\n", "",{"version":3,"sources":["webpack://./src/styles/scenario-edit.scss"],"names":[],"mappings":"AAAA,eACE,eAAgB,CAChB,eAAgB","sourcesContent":[".scenario-edit {\n  margin-left: 5px;\n  margin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
